import React from 'react';
import PropTypes from 'prop-types';
import { DropdownItem } from '@ux/dropdown';

const DefaultItem = ({ item, onSelect, selected }) => {
  return (
    <DropdownItem onClick={ () => { onSelect(item); return true; } } active={ selected } >
      { item }
    </DropdownItem>
  );
};

DefaultItem.defaultProps = {
  onSelect: () => {}
};

DefaultItem.propTypes = {
  item: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  selected: PropTypes.bool
};

export default DefaultItem;



// WEBPACK FOOTER //
// ./node_modules/@ux/search/default-item.js